
import { defineComponent } from "vue";

export default defineComponent({
  name: "binary-tree-skeleton",
});
